import { useEffect } from 'react';
import dayjs from 'dayjs';
import { encrypted } from '../utils/utility';
import { getDecryptedToken } from '../utils/functions/authHelpers';

const EXPIRY_CHECK_TIME_IN_MLS = 5 * 60 * 1000;

export const tokenExpiringInMs = (
  token: string,
  timeInMs: number
) => {
  try {
    const expiry = JSON.parse(
      atob(token.split('.')[1])
    ).exp;
    return dayjs.unix(expiry).diff(dayjs()) <= timeInMs;
  } catch {
    return true;
  }
};

export const useRefreshTokenBeforeExpiry = () => {
  const getRefreshTokenIfExpiringInTimeLimit = async () => {
    const encryptedToken = localStorage.getItem('authToken');

    if (!encryptedToken) return;

    let decryptedString: string;

    try {
      decryptedString = encrypted.decrypt(encryptedToken);
    } catch (err) {
      console.error('Failed to decrypt auth token:', err);
      return;
    }

    let tokenObj: { token: string } | null = null;

    try {
      tokenObj = JSON.parse(decryptedString);
    } catch (err) {
      console.error('Failed to parse decrypted token:', err);
      return;
    }

    const token = tokenObj?.token;

    if (!token || tokenExpiringInMs(token, EXPIRY_CHECK_TIME_IN_MLS)) {
      // Token is expiring soon, but with SSO we rely on backend session management
      // If token expires, user will need to re-authenticate via SSO
      console.warn('Token expiring soon. User may need to re-authenticate.');
    }
  };

  useEffect(() => {
    const token = getDecryptedToken();
    if (!token) return;

    let interval: NodeJS.Timeout | null = null;

    // checking for first time
    getRefreshTokenIfExpiringInTimeLimit();
    interval = setInterval(() => {
      // checking in intervals
      getRefreshTokenIfExpiringInTimeLimit();
    }, EXPIRY_CHECK_TIME_IN_MLS);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);
};
